const PERMISSION_KEY= "company:bc_industry_activity";
const PAGE_URL = {
    B_C_INDUSTRY_ACTIVITY_PAGE: "/admin/company/bc-industry-activity"
}

export {PERMISSION_KEY, PAGE_URL}

